import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import {
  GET_USER_PROFILE_PATIENT_MASTER_SECURE_URL,
  GET_USER_PROFILE_PATIENT_MASTER_URL,
} from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type {
  GetProfilePatientMasterPayload,
  GetProfilePatientMasterResult,
} from '../types/getProfilePatientMaster.types';

export const PROFILE_PATIENT_MASTER_TAGS = 'getProfilePatientMaster';

export const getProfilePatientMaster = (builder: BuilderType) =>
  builder.query<GetProfilePatientMasterResult, GetProfilePatientMasterPayload>({
    query: ({ secure, ...data }) => ({
      data,
      method: 'POST',
      url: secure ? GET_USER_PROFILE_PATIENT_MASTER_SECURE_URL : GET_USER_PROFILE_PATIENT_MASTER_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetProfilePatientMasterResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
    providesTags: [PROFILE_PATIENT_MASTER_TAGS],
  });
